// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.image-editing-workspace {
  display: flex;
  flex-direction: column;
  gap: 10px;
  width: 100%;
  height: 100%;
  min-height: 0;
}

.image-editing-toolbar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  flex-wrap: wrap;
  flex-shrink: 0;
}

.image-editing-tool-group,
.image-editing-save-actions {
  display: inline-flex;
  align-items: center;
  gap: 6px;
}

.image-editing-tool-button,
.image-editing-secondary-button,
.image-editing-primary-button {
  height: 32px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  border-radius: 3px;
  border: 1px solid var(--color-border-input);
  background: var(--color-bg-input);
  color: var(--color-text-secondary);
  font-size: 12px;
  font-weight: 600;
  font-family: inherit;
  cursor: pointer;
  transition: background 0.15s ease, color 0.15s ease, border-color 0.15s ease, opacity 0.15s ease;
}

.image-editing-tool-button {
  width: 34px;
  padding: 0;
}

.image-editing-secondary-button,
.image-editing-primary-button {
  padding: 0 11px;
}

.image-editing-tool-button:hover:not(:disabled),
.image-editing-secondary-button:hover:not(:disabled) {
  background: var(--color-bg-user-bubble);
  color: var(--color-text-primary);
  border-color: var(--color-text-secondary);
}

.image-editing-tool-button.active {
  background: var(--color-text-primary);
  border-color: var(--color-text-primary);
  color: var(--color-bg-canvas-surface);
}

.image-editing-primary-button {
  background: var(--color-text-primary);
  border-color: var(--color-text-primary);
  color: var(--color-bg-canvas-surface);
}

.image-editing-primary-button:hover:not(:disabled) {
  opacity: 0.88;
}

.image-editing-primary-button:disabled,
.image-editing-secondary-button:disabled {
  opacity: 0.45;
  cursor: not-allowed;
}

.image-editing-color {
  width: 32px;
  height: 32px;
  padding: 3px;
  border-radius: 3px;
  border: 1px solid var(--color-border-input);
  background: var(--color-bg-input);
  cursor: pointer;
}

.image-editing-adjustments {
  display: grid;
  grid-template-columns: repeat(5, minmax(120px, 1fr)) auto;
  align-items: center;
  gap: 8px;
  flex-shrink: 0;
  padding: 8px;
  border: 1px solid var(--color-border-input);
  border-radius: 4px;
  background: var(--color-bg-sidebar);
}

.image-editing-adjustment {
  display: grid;
  grid-template-columns: 1fr;
  gap: 4px;
  min-width: 0;
  color: var(--color-text-secondary);
  font-size: 11px;
  font-weight: 600;
}

.image-editing-adjustment input {
  width: 100%;
  min-width: 0;
}

.image-editing-adjustment output {
  color: var(--color-text-primary);
  font-size: 11px;
}

.image-editing-canvas-shell {
  flex: 1 1;
  min-height: 240px;
  min-width: 0;
  overflow: hidden;
  border: 1px solid var(--color-border-input);
  border-radius: 4px;
  background: var(--color-bg-canvas-surface);
}

.image-editing-prompt {
  flex-shrink: 0;
}

.image-editing-workspace--fullscreen {
  display: grid;
  grid-template-columns: 420px minmax(0, 1fr);
  grid-template-rows: minmax(0, 1fr);
  gap: 0;
  width: 100%;
  height: 100vh;
  min-height: 0;
  background: var(--color-bg-root);
  overflow: hidden;
}

.image-editing-workspace--fullscreen.image-editing-workspace--with-side-panel {
  grid-template-columns: 420px minmax(0, 1fr) 300px;
}

.image-editing-workspace--fullscreen .keyframe-editing-sidebar {
  height: 100vh;
  min-height: 0;
}

.image-editing-fullscreen-main {
  display: grid;
  grid-template-rows: minmax(0, 1fr) auto;
  min-width: 0;
  min-height: 0;
  height: 100vh;
  overflow: hidden;
  background: var(--color-bg-root);
}

.image-editing-fullscreen-canvas {
  position: relative;
  min-width: 0;
  min-height: 0;
  overflow: hidden;
  padding: 24px 24px 12px;
  box-sizing: border-box;
}

.image-editing-fullscreen-canvas .canvas-placeholder.editing-keyframe-canvas {
  width: 100%;
  height: 100%;
  background: transparent;
}

.image-editing-fullscreen-prompt {
  position: relative;
  padding: 0 16px 16px;
  z-index: 30;
}

.image-editing-fullscreen-side {
  min-width: 0;
  min-height: 0;
  height: 100vh;
  overflow: auto;
  border-left: 1px solid var(--color-border-input);
  background: var(--color-bg-sidebar);
}

@media (max-width: 860px) {
  .image-editing-adjustments {
    grid-template-columns: repeat(2, minmax(120px, 1fr));
  }

  .image-editing-workspace--fullscreen,
  .image-editing-workspace--fullscreen.image-editing-workspace--with-side-panel {
    grid-template-columns: minmax(0, 1fr);
  }

  .image-editing-workspace--fullscreen .keyframe-editing-sidebar,
  .image-editing-fullscreen-side {
    display: none;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/editor/ImageEditingWorkspace.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,WAAW;EACX,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,eAAe;EACf,cAAc;AAChB;;AAEA;;EAEE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;AACV;;AAEA;;;EAGE,YAAY;EACZ,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,kBAAkB;EAClB,2CAA2C;EAC3C,iCAAiC;EACjC,kCAAkC;EAClC,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,eAAe;EACf,gGAAgG;AAClG;;AAEA;EACE,WAAW;EACX,UAAU;AACZ;;AAEA;;EAEE,eAAe;AACjB;;AAEA;;EAEE,uCAAuC;EACvC,gCAAgC;EAChC,yCAAyC;AAC3C;;AAEA;EACE,qCAAqC;EACrC,uCAAuC;EACvC,qCAAqC;AACvC;;AAEA;EACE,qCAAqC;EACrC,uCAAuC;EACvC,qCAAqC;AACvC;;AAEA;EACE,aAAa;AACf;;AAEA;;EAEE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,2CAA2C;EAC3C,iCAAiC;EACjC,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,yDAAyD;EACzD,mBAAmB;EACnB,QAAQ;EACR,cAAc;EACd,YAAY;EACZ,2CAA2C;EAC3C,kBAAkB;EAClB,mCAAmC;AACrC;;AAEA;EACE,aAAa;EACb,0BAA0B;EAC1B,QAAQ;EACR,YAAY;EACZ,kCAAkC;EAClC,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,gCAAgC;EAChC,eAAe;AACjB;;AAEA;EACE,SAAW;EACX,iBAAiB;EACjB,YAAY;EACZ,gBAAgB;EAChB,2CAA2C;EAC3C,kBAAkB;EAClB,0CAA0C;AAC5C;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,2CAA2C;EAC3C,kCAAkC;EAClC,MAAM;EACN,WAAW;EACX,aAAa;EACb,aAAa;EACb,gCAAgC;EAChC,gBAAgB;AAClB;;AAEA;EACE,iDAAiD;AACnD;;AAEA;EACE,aAAa;EACb,aAAa;AACf;;AAEA;EACE,aAAa;EACb,uCAAuC;EACvC,YAAY;EACZ,aAAa;EACb,aAAa;EACb,gBAAgB;EAChB,gCAAgC;AAClC;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,gBAAgB;EAChB,uBAAuB;EACvB,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,oBAAoB;EACpB,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,aAAa;EACb,cAAc;EACd,gDAAgD;EAChD,mCAAmC;AACrC;;AAEA;EACE;IACE,oDAAoD;EACtD;;EAEA;;IAEE,qCAAqC;EACvC;;EAEA;;IAEE,aAAa;EACf;AACF","sourcesContent":[".image-editing-workspace {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n  width: 100%;\n  height: 100%;\n  min-height: 0;\n}\n\n.image-editing-toolbar {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 10px;\n  flex-wrap: wrap;\n  flex-shrink: 0;\n}\n\n.image-editing-tool-group,\n.image-editing-save-actions {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n}\n\n.image-editing-tool-button,\n.image-editing-secondary-button,\n.image-editing-primary-button {\n  height: 32px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 6px;\n  border-radius: 3px;\n  border: 1px solid var(--color-border-input);\n  background: var(--color-bg-input);\n  color: var(--color-text-secondary);\n  font-size: 12px;\n  font-weight: 600;\n  font-family: inherit;\n  cursor: pointer;\n  transition: background 0.15s ease, color 0.15s ease, border-color 0.15s ease, opacity 0.15s ease;\n}\n\n.image-editing-tool-button {\n  width: 34px;\n  padding: 0;\n}\n\n.image-editing-secondary-button,\n.image-editing-primary-button {\n  padding: 0 11px;\n}\n\n.image-editing-tool-button:hover:not(:disabled),\n.image-editing-secondary-button:hover:not(:disabled) {\n  background: var(--color-bg-user-bubble);\n  color: var(--color-text-primary);\n  border-color: var(--color-text-secondary);\n}\n\n.image-editing-tool-button.active {\n  background: var(--color-text-primary);\n  border-color: var(--color-text-primary);\n  color: var(--color-bg-canvas-surface);\n}\n\n.image-editing-primary-button {\n  background: var(--color-text-primary);\n  border-color: var(--color-text-primary);\n  color: var(--color-bg-canvas-surface);\n}\n\n.image-editing-primary-button:hover:not(:disabled) {\n  opacity: 0.88;\n}\n\n.image-editing-primary-button:disabled,\n.image-editing-secondary-button:disabled {\n  opacity: 0.45;\n  cursor: not-allowed;\n}\n\n.image-editing-color {\n  width: 32px;\n  height: 32px;\n  padding: 3px;\n  border-radius: 3px;\n  border: 1px solid var(--color-border-input);\n  background: var(--color-bg-input);\n  cursor: pointer;\n}\n\n.image-editing-adjustments {\n  display: grid;\n  grid-template-columns: repeat(5, minmax(120px, 1fr)) auto;\n  align-items: center;\n  gap: 8px;\n  flex-shrink: 0;\n  padding: 8px;\n  border: 1px solid var(--color-border-input);\n  border-radius: 4px;\n  background: var(--color-bg-sidebar);\n}\n\n.image-editing-adjustment {\n  display: grid;\n  grid-template-columns: 1fr;\n  gap: 4px;\n  min-width: 0;\n  color: var(--color-text-secondary);\n  font-size: 11px;\n  font-weight: 600;\n}\n\n.image-editing-adjustment input {\n  width: 100%;\n  min-width: 0;\n}\n\n.image-editing-adjustment output {\n  color: var(--color-text-primary);\n  font-size: 11px;\n}\n\n.image-editing-canvas-shell {\n  flex: 1 1 0;\n  min-height: 240px;\n  min-width: 0;\n  overflow: hidden;\n  border: 1px solid var(--color-border-input);\n  border-radius: 4px;\n  background: var(--color-bg-canvas-surface);\n}\n\n.image-editing-prompt {\n  flex-shrink: 0;\n}\n\n.image-editing-workspace--fullscreen {\n  display: grid;\n  grid-template-columns: 420px minmax(0, 1fr);\n  grid-template-rows: minmax(0, 1fr);\n  gap: 0;\n  width: 100%;\n  height: 100vh;\n  min-height: 0;\n  background: var(--color-bg-root);\n  overflow: hidden;\n}\n\n.image-editing-workspace--fullscreen.image-editing-workspace--with-side-panel {\n  grid-template-columns: 420px minmax(0, 1fr) 300px;\n}\n\n.image-editing-workspace--fullscreen .keyframe-editing-sidebar {\n  height: 100vh;\n  min-height: 0;\n}\n\n.image-editing-fullscreen-main {\n  display: grid;\n  grid-template-rows: minmax(0, 1fr) auto;\n  min-width: 0;\n  min-height: 0;\n  height: 100vh;\n  overflow: hidden;\n  background: var(--color-bg-root);\n}\n\n.image-editing-fullscreen-canvas {\n  position: relative;\n  min-width: 0;\n  min-height: 0;\n  overflow: hidden;\n  padding: 24px 24px 12px;\n  box-sizing: border-box;\n}\n\n.image-editing-fullscreen-canvas .canvas-placeholder.editing-keyframe-canvas {\n  width: 100%;\n  height: 100%;\n  background: transparent;\n}\n\n.image-editing-fullscreen-prompt {\n  position: relative;\n  padding: 0 16px 16px;\n  z-index: 30;\n}\n\n.image-editing-fullscreen-side {\n  min-width: 0;\n  min-height: 0;\n  height: 100vh;\n  overflow: auto;\n  border-left: 1px solid var(--color-border-input);\n  background: var(--color-bg-sidebar);\n}\n\n@media (max-width: 860px) {\n  .image-editing-adjustments {\n    grid-template-columns: repeat(2, minmax(120px, 1fr));\n  }\n\n  .image-editing-workspace--fullscreen,\n  .image-editing-workspace--fullscreen.image-editing-workspace--with-side-panel {\n    grid-template-columns: minmax(0, 1fr);\n  }\n\n  .image-editing-workspace--fullscreen .keyframe-editing-sidebar,\n  .image-editing-fullscreen-side {\n    display: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
